import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"
import { t } from "ttag"
import { PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"
import React from "react"

export const DeleteSurveyDialog: React.FC<CancelChangesDialogProps> = (props) => (
  <Dialog open={props.isOpen}>
    <DialogTitle>{t`Are you sure you want to delete this survey?`}</DialogTitle>
    <DialogContent>
      {t`Please confirm the deletion of the survey.`}
    </DialogContent>
    <DialogActions>
      <PrimaryButton
        destructive
        onClick={() => props.onConfirm(props.surveyId)}
        isLoading={props.isLoading}
      >
        {t`Confirm`}
      </PrimaryButton>
      <PrimaryButton onClick={props.onCancel}>
        {t`Cancel`}
      </PrimaryButton>
    </DialogActions>
  </Dialog>
)

interface CancelChangesDialogProps {
  isOpen: boolean,
  surveyId: number,
  isLoading: boolean,
  onConfirm: (id: number) => void,
  onCancel: () => void,
}
